/* eslint-disable @typescript-eslint/no-explicit-any */
import Wix from './wix-sdk-polyfill';
import { mergeGlobalSettingInStore } from '../actions/settings';

const showContent = () => {
  const rootEl = document.getElementById('root');
  if (rootEl) {
    setTimeout(() => {
      rootEl.style.opacity = '1';
    }, 0);
  }
};

export const renderOnlyWithStyles = (store: any) => {
  let siteColors = Wix.Styles.getSiteColors();
  let siteTextPresets = Wix.Styles.getSiteTextPresets();

  // In case styles do not appear
  const timeout = setTimeout(showContent, 1000);

  if (!siteColors || !siteTextPresets) {
    Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, () => {
      siteColors = Wix.Styles.getSiteColors();
      siteTextPresets = Wix.Styles.getSiteTextPresets();
      store.dispatch(mergeGlobalSettingInStore({ siteColors, siteTextPresets }));
      clearTimeout(timeout);
      showContent();
    });
  } else {
    store.dispatch(mergeGlobalSettingInStore({ siteColors, siteTextPresets }));
    clearTimeout(timeout);
    showContent();
  }
};
